import type { BidStatus } from './types';

/** The ONE list of bid categories: the form's Category select and the AI that classifies an uploaded PDF both use it. */
export const BID_CATEGORIES = [
  'Plans & Permits',
  'Surveys',
  'Site Preparation',
  'Demolition',
  'Earthworks',
  'Utilities',
  'Erosion & Drainage',
  'Inspections',
  'Concrete',
  'Masonry',
  'Structural Steel',
  'Framing',
  'Roofing',
  'Siding',
  'Insulation',
  'Waterproofing',
  'Windows & Doors',
  'Plumbing',
  'HVAC / Mechanical',
  'Electrical',
  'Fire Protection',
  'Low Voltage / Data',
  'Drywall',
  'Paint',
  'Flooring',
  'Tile & Stone',
  'Millwork and Trim',
  'Interior Finishes',
  'Specialties',
  'Landscaping',
  'Exterior Finishes',
  'Decks / Porches',
  'Paving',
  'Fencing',
  'Site Lighting',
  'General',
  'Other',
] as const;

export type BidCategory = typeof BID_CATEGORIES[number];

export const BID_STATUS_OPTIONS: { label: string; value: BidStatus }[] = [
  { label: 'Received', value: 'received' },
  { label: 'Under Review', value: 'under_review' },
  { label: 'Awarded', value: 'awarded' },
  { label: 'Rejected', value: 'rejected' },
];
